import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import BrandNavbar from '../components/dashboard/BrandNavbar';
import BrandAccountSidebar from '../components/brand/BrandAccountSidebar';
import MyCollabSection from '../components/brand/account/MyCollabSection';
import MyProfileSection from '../components/brand/account/MyProfileSection';
import MyBrandsSection from '../components/brand/account/MyBrandsSection';
import SalesSection from '../components/brand/account/SalesSection';
import SubscriptionsSection from '../components/brand/account/SubscriptionsSection';
import BillingSection from '../components/brand/account/BillingSection';
// import NotificationsSection from '../components/brand/account/NotificationsSection'; // DISABLED
// import ShipmentsSection from '../components/brand/account/ShipmentsSection'; // DISABLED
import ReviewsSection from '../components/brand/account/ReviewsSection';
import SecuritySection from '../components/brand/account/SecuritySection';
import PrivacySection from '../components/brand/account/PrivacySection';
import SupportSection from '../components/brand/account/SupportSection';
import './BrandMyAccount.css';

const BrandMyAccount = () => {
  const { userId } = useParams();
  const [activeSection, setActiveSection] = useState('mycollab');
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleSectionChange = (sectionId) => {
    setActiveSection(sectionId);
    setIsMobileMenuOpen(false);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const getSectionTitle = () => {
    const titles = {
      'mycollab': 'MyCollab',
      'profile': 'My Profile',
      'brands': 'My Brands',
      'sales': 'Sales',
      // 'subscriptions': 'Subscriptions', // DISABLED
      // 'billing': 'Billing', // DISABLED
      // 'notifications': 'Notifications', // DISABLED
      // 'shipments': 'Shipments', // DISABLED
      'reviews': 'Reviews',
      'security': 'Security',
      'privacy': 'Privacy',
      'support': 'Support'
    };
    return titles[activeSection] || 'Account Settings';
  };

  const renderContent = () => {
    switch (activeSection) {
      case 'mycollab':
        return <MyCollabSection userId={userId} />;
      case 'profile':
        return <MyProfileSection userId={userId} />;
      case 'brands':
        return <MyBrandsSection userId={userId} />;
      case 'sales':
        return <SalesSection userId={userId} />;
      // case 'subscriptions': // DISABLED
      //   return <SubscriptionsSection userId={userId} />;
      // case 'billing': // DISABLED
      //   return <BillingSection userId={userId} />;
      // case 'notifications': // DISABLED
      //   return <NotificationsSection userId={userId} />;
      // case 'shipments': // DISABLED
      //   return <ShipmentsSection userId={userId} />;
      case 'reviews':
        return <ReviewsSection userId={userId} />;
      case 'security':
        return <SecuritySection userId={userId} />;
      case 'privacy':
        return <PrivacySection userId={userId} />;
      case 'support':
        return <SupportSection userId={userId} />;
      default:
        return <MyCollabSection userId={userId} />;
    }
  };

  return (
    <div className="min-h-screen dashboard-shell">
      <BrandNavbar />

      <div className="brand-account-container">
        {/* Mobile Menu Button */}
        <button
          onClick={toggleMobileMenu}
          className="mobile-menu-toggle md:hidden"
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>

        {/* Sidebar */}
        <div className={`sidebar-wrapper ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
          <BrandAccountSidebar
            activeSection={activeSection}
            onSectionChange={handleSectionChange}
          />
        </div>

        {/* Mobile Overlay */}
        {isMobileMenuOpen && (
          <div
            className="mobile-overlay md:hidden"
            onClick={() => setIsMobileMenuOpen(false)}
          />
        )}

        {/* Main Content */}
        <div className="account-main-content">
          <div className="content-header">
            <div className="section-kicker mb-3">Account workspace</div>
            <h1 className="section-main-title">{getSectionTitle()}</h1>
          </div>
          <div className="content-body">
            {renderContent()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BrandMyAccount;
